import React from 'react'

interface Props {
  className?: string
}

const Underline = ({ className }: Props) => (
  <svg
    className={className}
    width='159'
    height='13'
    viewBox='0 0 159 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2 6.82143L157 2L23.1222 11H139.916'
      stroke='#FF869C'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default Underline
